import styled from 'styled-components';

export const Container = styled.div`
	max-width: 500px;
	margin: 0 auto;
	padding-inline: 16px;
`;
